module.exports = __webpack_public_path__ + "static/media/JD.68a1f57b.svg";